import React from 'react';
import { Camera, Image as ImageIcon } from 'lucide-react';
import './Gallery.css';

const Gallery = () => {
  const galleryItems = [
    {
      image: 'https://i.imgur.com/GINkDq3.jpg',
      title: 'Pastor Eddy',
      subtitle: 'Pasteur Eddy',
      color: '#D4A574'
    },
    {
      image: 'https://i.imgur.com/P0bAyrH.jpg',
      title: 'Notre Famille d\'Église',
      subtitle: 'Our Church Family / Unsere Kirchenfamilie',
      color: '#CD853F'
    },
    {
      image: 'https://i.imgur.com/lqPxRF1.jpg',
      title: 'Louange & Adoration',
      subtitle: 'Praise & Worship / Lobpreis & Anbetung',
      color: '#8B6F47'
    },
    {
      image: 'https://i.imgur.com/0QWaGFu.jpg',
      title: 'Évangélisation',
      subtitle: 'Evangelism / Evangelisation',
      color: '#D4A574'
    },
    {
      image: 'https://i.imgur.com/eQok7oE.jpg',
      title: 'Célébration en Famille',
      subtitle: 'Family Celebration / Familienfeier',
      color: '#CD853F'
    },
    {
      image: 'https://i.imgur.com/FphETIE.jpg',
      title: 'Équipe de Leadership',
      subtitle: 'Leadership Team / Leitungsteam',
      color: '#8B6F47'
    },
    {
      image: 'https://i.imgur.com/vvX4p4a.jpg',
      title: 'Notre Communauté',
      subtitle: 'Our Community / Unsere Gemeinschaft',
      color: '#D4A574'
    }
  ];

  return (
    <section id="galerie" className="section">
      <div className="container">
        <h2 className="section-title">
          <Camera className="title-icon" size={36} />
          {' '}Notre Communauté / Our Community / Unsere Gemeinschaft
        </h2>

        <div className="gallery">
          {galleryItems.map((item, index) => (
            <div key={index} className="gallery-item" style={{ animationDelay: `${index * 0.1}s` }}>
              <img 
                src={item.image} 
                alt={item.title}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="gallery-placeholder" style={{ 
                background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
                display: 'none'
              }}>
                <ImageIcon size={64} color="white" opacity={0.5} />
              </div>
              {index === 0 && (
                <div className="gallery-caption">
                  <strong>{item.title}</strong>
                  <br />
                  {item.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="photo-success">
          <h4>✅ Photos intégrées avec succès! / Photos successfully integrated!</h4>
          <p>
            Vos 7 photos sont maintenant affichées dans la galerie.<br />
            Your 7 photos are now displayed in the gallery.<br />
            Ihre 7 Fotos werden jetzt in der Galerie angezeigt.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
